export const lerp = (a, b, t) => a + (b - a) * t;

//get file + ext name from full path
export const getFileName = (path) => path.split("/").pop();

export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
